
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisSarAircraftHelicopterFilled as ObiAisSarAircraftHelicopterFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-sar-aircraft-helicopter-filled.js';
 
 
 

 
 export const ObiAisSarAircraftHelicopterFilled = createComponent({
   react: React,
   tagName: 'obi-ais-sar-aircraft-helicopter-filled',
   elementClass: ObiAisSarAircraftHelicopterFilledElement,
   events: {
     
   }
  });
 
 